<template>
  <div class="dynamic-container">
    <div class="fixed">
      <div>
        <van-search
          v-model="searchOptions.phone"
          show-action
          clear-trigger="always"
          placeholder="请输入电话号码"
          @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
      <div class="select-container">
        <div>
          <div class="button-list">
            <div
              class="button-item"
              :class="{
                'button-item-active': curTab1 === btnindex
              }"
              v-for="(btnitem, btnindex) in tabArray"
              :key="btnindex"
              @click.stop="selectTab1(btnindex)"
            >
              {{ btnitem.label }}</div
            >
          </div>
        </div>
      </div>
      <div class="select-list">
        <div class="select-item" @click="bindTimeChange()">
          {{ timeSelectData.text }}
        </div>
        <div class="clear" @click.stop="bindClear">清除</div>
      </div>
      <!--  -->
      <div class="nav-list">
        <div
          class="nav-item"
          :class="{ 'nav-item-active': curNav == index }"
          v-for="(item, index) in navList"
          :key="index"
          @click.stop="changeNav(index)"
        >
          <span>{{ item.name }}</span
          ><span v-if="index == 0 && item.total">({{ item.total }})</span>
        </div>
      </div>
    </div>
    <div class="page-content">
      <div
        class="page-scroll"
        @scroll="bindScroll($event, index)"
        :ref="'scroll-' + index"
        v-for="(item, index) in navList"
        :key="index"
        v-show="curNav == index"
      >
        <van-pull-refresh
          style="min-height: 100%"
          v-model="navList[curNav].refreshing"
          @refresh="onRefresh(curNav)"
        >
          <van-list
            style="min-height: 80vh"
            v-if="item.loaded"
            v-model="item.isLoading"
            :finished="item.finished"
            finished-text="没有更多了"
            :immediate-check="false"
            @load="loadData(false)"
          >
            <ReviewsItem
              v-if="curNav == 0"
              :type="1"
              :data="item.data"
              @like="likeDynamic"
              @into="intoDynamic"
              @userinfo="intoInfo"
            ></ReviewsItem>
            <ReviewsItem
              v-if="curNav == 1"
              :type="2"
              :data="item.data"
              @like="likeDynamic"
              @into="intoDynamic"
              @userinfo="intoInfo"
            ></ReviewsItem>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <!-- 时间选择 -->
    <van-popup v-model="timeSelectData.showPicker" position="bottom">
      <van-datetime-picker
        v-model="pickerTime"
        type="date"
        title="选择年月日"
        :min-date="timeSelectData.minDate"
        :max-date="timeSelectData.maxDate"
        @cancel="bindTimeCancel"
        @confirm="bindTimeConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { dietData, formatTime } from './data'
import ReviewsItem from './components/review-item.vue'
export default {
  name: 'not-camp-review-tool-list',
  components: { ReviewsItem },
  data() {
    return {
      searchOptions: {
        phone: '',
        tab1: 1,
        time: '',
        tab2: 0
      },
      pickerTime: new Date(),
      id: '', //营期id
      rank_num: 0, //风险人数
      curSelect: 0,
      currentDate: new Date(), //当前时间
      curTab1: 0,
      tabArray: [
        {
          id: 1,
          label: '分配给我'
        },
        {
          id: 2,
          label: '全部'
        }
      ],
      dietSelectData: {
        index: 0,
        title: '餐卡类型',
        text: '饮食打卡',
        key: 'name',
        data: dietData[1],
        list: dietData,
        showPicker: false,
        default: 1
      },
      timeSelectData: {
        showPicker: false,
        data: '',
        value: new Date(),
        title: '选择时间',
        text: '全部日期',
        minDate: new Date(2010, 1, 1),
        maxDate: new Date()
      },
      curNav: 0,
      navList: [
        {
          name: '未点评',
          scrollTop: 0,
          isLoading: false,
          finished: false,
          loaded: false,
          total: '',
          time: '',
          page: 1,
          data: [],
          refreshing: false
        },
        {
          name: '已点评',
          scrollTop: 0,
          isLoading: false,
          finished: false,
          loaded: false,
          time: '',
          total: '',
          page: 1,
          data: [],
          refreshing: false
        }
      ],
      typeList: [1, 2],
      userAvg: null,
      showPicker: false
    }
  },
  watch: {
    $route(to, from) {
      //从新老点评详情界面返回则不刷新，其他情况刷新
      if (
        to.name == 'nutritionist-tool-diet-list' &&
        from.name !== 'nutritionist-tool-review-detail' &&
        from.name !== 'nutritionist-tool-review-old-detail' &&
        from.name !== 'user-data'
      ) {
        this.init()
      }
    }
  },
  created() {
    this.init()
  },
  activated() {
    console.log('嘻嘻')
    this.updateNotComment()
    this.initScroll()
  },
  methods: {
    resetLoad() {
      this.navList[this.curNav].data = []
      this.navList[this.curNav].page = 1
      this.navList[this.curNav].isLoading = false
      this.navList[this.curNav].finished = false
    },
    updateNotComment() {
      let curNav = this.curNav
      let id = localStorage.getItem('finishedCommentId')
      if (!id || curNav != 0) {
        return
      }
      let delIndex
      let data = this.navList[curNav].data
      for (let i = 0; i < data.length; i++) {
        if (data[i].id == id) {
          delIndex = i
          break
        }
      }
      if (delIndex !== undefined) {
        data.splice(delIndex, 1)
        this.navList[curNav].total--
      }
      localStorage.removeItem('finishedCommentId')
    },
    bindScroll(e, index) {
      let scrollTop = e.target.scrollTop
      this.navList[index].scrollTop = scrollTop
    },
    initScroll() {
      this.navList.map((item, index) => {
        if (item.loaded) {
          console.dir(this.$refs['scroll-' + index])
          let dom = this.$refs['scroll-' + index]
          dom = Array.isArray(dom) ? dom[0] : dom
          dom.scrollTo(0, item.scrollTop)
        }
      })
    },
    init() {
      //初始化data数据
      console.log('初始化')
      Object.assign(this.$data, this.$options.data())
      this.getQuery()
      this.loadData(true)
    },
    getQuery() {
      if (this.$route.query.title) {
        document.title = this.$route.query.title
      }
      if (this.$route.query.id) {
        this.id = this.$route.query.id
      }
    },
    onSearch() {
      this.resetLoad()
      this.loadData()
    },
    bindDietChange() {
      this.dietSelectData.showPicker = true
    },
    bindTimeChange() {
      this.timeSelectData.showPicker = true
    },
    //切换餐卡类型
    selectTab1(index) {
      if (this.curTab1 == index) {
        return
      }
      this.curTab1 = index
      this.searchOptions.tab1 = this.tabArray[index].id
      this.resetLoad()
      this.loadData()
    },
    bindDietCancel() {
      this.dietSelectData.showPicker = false
    },
    bindTimeConfirm(date) {
      this.timeSelectData.showPicker = false
      let str = formatTime(date)
      this.searchOptions.time = str
      this.timeSelectData.text = str
      this.resetLoad()
      this.loadData()
    },
    bindTimeCancel() {
      this.timeSelectData.showPicker = false
    },
    bindClear() {
      this.searchOptions.time = ''
      this.timeSelectData.text = '全部日期'
      this.resetLoad()
      this.loadData()
    },
    clearLoaded() {
      this.navList.map((item) => {
        item.loaded = false
        item.finished = false
      })
    },
    /*  */
    onRefresh(curNav) {
      this.resetLoad()
      this.loadData()
    },
    toWarningMembers() {
      if (!this.$http._isApp()) {
        //旧版本前往小程序
        wx.miniProgram.navigateTo({
          url: `/pages/leaderboard/leaderboard?title=${this.$route.query.title}&pid=${this.$route.query.id}`
        })
      }
    },
    changeNav(index) {
      if (this.curNav == index) {
        return
      }
      this.searchOptions.tab2 = index
      this.curNav = index
      this.navList[index].finished = false
      this.navList.map((item1, index1) => {
        if (index != index1) {
          item1.list = []
        }
      })
      this.resetLoad()
      this.loadData()
    },
    bindPickerCancel() {
      this.showPicker = false
    },
    bindPickerConfirm(item, index) {
      this.showPicker = false
      if (item instanceof Date) {
        this.setTimeStr(item)
      } else {
        this.selectData[this.curSelect].index = index
        this.selectData[this.curSelect].text =
          this.selectData[this.curSelect].list[index][
            this.selectData[this.curSelect].key
          ]
      }
    },
    getTimeStr() {
      let res
      this.selectData.map((item) => {
        if (item.val == 'time') {
          res = item.text == '全部日期' ? '' : item.text.replace(/\./g, '-')
        }
      })
      return res
    },
    setTimeStr(data) {
      this.selectData.map((item) => {
        if (item.val == 'time') {
          item.text = formatTime(data)
        }
      })
    },
    async loadData() {
      let index = this.curNav
      let { phone, tab1, time, tab2 } = this.searchOptions
      let page = this.navList[index].page
      this.navList[index].isLoading = true
      let params = {
        is_comment: tab2,
        date: time,
        page: page,
        phone: phone,
        type: tab1,
        pageSize: 20,
        meal_attr: this.$route.query.meal_attr || 0
      }
      let res = await this.$http
        .getApp('api/v1/NutritionServicesComment/getCommentList', params)
        .catch(() => {
          this.navList[index].finished = true
        })
      this.navList[index].isLoading = false
      this.navList[index].loaded = true
      this.navList[index].refreshing = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data.data.length) {
            let arr = this.dealData(res.data.data)
            let isScrollTop = this.navList[index].data.length != 0
            this.navList[index].data = this.navList[index].data.concat(arr)
            if (isScrollTop) {
              this.$nextTick(() => {
                let el = this.$refs['scroll-' + index]
                el = Array.isArray(el) ? el[0] : el
                el.scrollTop = 0
              })
            }
            this.navList[index].page++
          } else {
            this.navList[index].finished = true
          }
          this.navList[index].time = res.data.time || ''
          this.navList[index].total = res.data.total
        } else {
          this.navList[index].finished = true
        }
        this.navList[index].isLoading = false
      }
    },
    dealData(data) {
      data = data.map((item) => {
        item.meal_img = item.meal_img ? item.meal_img.split(',') : []
        return item
      })
      return data
    },
    //点赞动态
    likeDynamic(index, curNav) {
      curNav = +curNav - 1
      let is_love = this.navList[curNav].data[index].is_love
      let tid = this.navList[curNav].data[index].id
      let flag = 1
      if (is_love) {
        flag = 0
      }
      let params = {
        tab_type: 'weapp_group',
        tid,
        flag
      }
      this.$http
        .postApp('member/AppCamp/optionLove', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            let zan_num = this.navList[curNav].data[index].zan_num
            this.navList[curNav].data[index].zan_num = flag
              ? ++zan_num
              : --zan_num < 0
              ? 0
              : zan_num
            this.navList[curNav].data[index].is_love = !is_love
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
    },
    intoDynamic(item, index) {
      let id = item.id
      //新版本在h5点评
      this.$router.push({
        path: '/not-camp-review-tool/detail',
        query: {
          id,
          truename: item.truename,
          nickname: item.nickname,
          head_img: item.head_img
        }
      })
    },
    intoInfo(item) {
      this.$router.push({
        name: 'user-data',
        query: {
          unify_id: item.unify_id,
          pid: this.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dynamic-container {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  height: 100vh;
  position: relative;

  .fixed {
    position: sticky;
    width: 100%;
    top: 0;

    .warning {
      width: 100%;
      box-sizing: border-box;
      height: 30px;
      text-align: center;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #f04646;
      color: #fff;

      .rank {
        margin-right: 30px;
      }

      .warn-btn {
        font-weight: 700;
        font-size: 13px;
        margin-left: 5px;
      }
    }

    .select-list {
      margin-top: 10px;
      width: 100%;
      box-sizing: border-box;
      padding: 0 15px;
      padding-right: 10px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .select-item {
        font-weight: 600;
        position: relative;
        width: 160px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        box-sizing: border-box;
        height: 28px;
        padding: 0 10px;
        margin: 0 4px;
        display: flex;
        align-items: center;
        font-size: 12px;
        text-align: left;
        background-color: #ffffff;
        border-radius: 6px;
        border: solid 1px #f1f1f1;
      }

      .select-item::after {
        content: '';
        position: absolute;
        top: 50%;
        right: 6px;
        width: 0;
        height: 0;
        transition: all 0.5s;
        transform: translate(0, -25%);
        border-left: 5px solid #fff;
        border-right: 5px solid #fff;
        border-top: 5px solid #bbb;
        border-bottom: 5px solid #fff;
      }

      .clear {
        font-size: 11px;
        color: #ff5a5a;
      }
    }

    .nav-list {
      margin: 25px auto 17px;
      display: flex;
      align-items: center;
      line-height: 26px;
      width: 335px;
      height: 30px;
      background-color: #ffffff;
      border-radius: 6px;
      box-sizing: border-box;
      border: solid 2px #f04646;

      .nav-item {
        width: 50%;
        height: 100%;
        color: #000;
        font-size: 13px;
        text-align: center;
        border-radius: 6px;
      }

      .nav-item-active {
        background-color: #f04646;
        color: #fff;
      }

      .nav-item:first-child {
        border-radius: 0px 6px 6px 0px;
      }

      .nav-item:last-child {
        border-radius: 6px 0px 0px 6px;
      }
    }
  }

  .page-content {
    width: 100%;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;

    .page-scroll {
      height: 100%;
      overflow-y: scroll;
    }
  }
}

.select-container {
  padding: 0px 16px;
  box-sizing: border-box;
}

.select-container .button-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.select-container .button-item {
  width: 80px;
  height: 30px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 15px;
  border: solid 1px #f1f1f1;
  font-size: 13px;
  line-height: 30px;
  color: #383d48;
  margin-right: 6px;
  margin-bottom: 6px;
  text-align: center;
}

.select-container .select-title {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  margin-bottom: 5px;
}

.select-container .button-item-active {
  border: solid 1px #383d48;
}

.select-container .button-item:last-child {
  margin-right: 0px;
}
</style>
